import jwtDecode from 'jwt-decode';
/* eslint-disable camelcase */

class JwtService {
	isAuthTokenValid = access_token => {
		if (!access_token) {
			return false;
		}
		const decoded = jwtDecode(access_token);
		const currentTime = Date.now() / 1000;

		if (decoded.exp < currentTime) {
			return false;
		}

		return true;
	};
}

const instance = new JwtService();

export default instance;
